import { HOURS_BANNER_DINELATE } from '../../constants'
import { TradingHour, ParsedOpeningHourWithStatus } from './types'
import { parseOpeningHours } from './parse-opening-hours'
import { getNonBannerDescription } from './get-non-banner-hours'

export function parseCentreOrLinkedStoreHours(
  tradingHours: TradingHour[],
  centreTimeZone: string,
  centreFeatures?: string[]
): ParsedOpeningHourWithStatus[] {
  const parsedHours = parseOpeningHours(
    tradingHours,
    centreTimeZone,
    centreFeatures
  )
  const isLateNight = (centreFeatures || []).includes('Late Night Dining')
  const defaultDesc = isLateNight ? HOURS_BANNER_DINELATE : ''
  return parsedHours.map(centreHour => ({
    ...centreHour,
    text: getNonBannerDescription(
      undefined,
      centreHour,
      // This is a hack to deal with already parsed data instead of an
      // intermediate form. To be remove when refactoring.
      centreHour.hours[0] === 'Closed' ? '' : defaultDesc
    ),
  }))
}
